export default {
	title: "Vigilância",
	url: "vigilancia",
	subtitle: "Relatório de vigilância estratégica gerado por pesquisa anonimizada: o tema do projeto é neutralizado antes de qualquer consulta a fontes públicas. O relatório cobre o contexto macro (PESTEL), setorial (5 forças de Porter) e interno, com sinais fortes e fracos.",
	current: "Relatório atual",
	archive: "Arquivos",
	context_tab: "Contexto",
	empty: "Ainda não há relatório de vigilância para este projeto.",
	generated_on: "Emitido em",
	actions: {
		generate: "Gerar um relatório",
		generate_new: "Gerar um novo relatório",
		generating: "Gerando… (cerca de dez minutos)",
		retry: "Tentar novamente",
		print: "Imprimir",
		delete: "Excluir este relatório",
		delete_confirm: "Excluir definitivamente este relatório?"
	},
	steps: {
		anonymizing: "Anonimização do tema",
		researching: "Pesquisa e redação",
		done: "Relatório disponível",
		elapsed: "há {{minutes}} min"
	},
	messages: {
		failed: "A geração falhou",
		neutral_subject: "Tema anonimizado enviado",
		confirm_title: "Iniciar uma vigilância anonimizada?",
		confirm_body: "O tema do projeto será anonimizado antes de qualquer pesquisa em fontes públicas. A geração do relatório leva cerca de dez minutos."
	}
};
